import {Component, Input} from '@angular/core';
import {ArticleInterface} from "../../drupal/entities";

@Component({
  selector: 'app-article-box',
  templateUrl: './article-box.component.html',
  styleUrls: ['./article-box.component.css']
})
export class ArticleBoxComponent {
  @Input() article: ArticleInterface | undefined;
}
